import React, { useState, useEffect } from "react";
import { UserRound, Bell } from "lucide-react";
import { format } from "date-fns";

import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import PostedJobsHistory from "../PostedJobsHistory";
import AIRequirementInput from "../AIRequirementInput";
import ProfessionalDetailsForm from "../ProfessionalDetailsForm";
import ShiftConfiguration from "../ShiftConfiguration";
import JobDescriptionCosts from "../JobDescriptionCosts";
import ShiftManagementTable from "../ShiftManagementTable";
import PocFacilitiesForm from "../pocFacilities";
import graphqlRequest from "../../../requestMethod";
import { message } from "../../../components/Common/SnakeAlert/SnakeAlert";
import SidebarNew from "../../../components/SidebarNew/SidebarNew";
import { useDispatch, useSelector } from "react-redux";
import {
  setOpenJobMatches,
  setActiveTab,
  setRecommendedUsers,
  setRecommendedUserAbsolute,
  setUserJobPost,
  setUserJobPostArray,
} from "../../../redux/userReducer";
import { Link, useNavigate } from "react-router-dom";
import {
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  Tooltip,
  TextareaAutosize,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { Modal as AntModal } from "antd";
import BranchInactiveModal from "../Modal/BranchInactiveModal";
import ShiftBufferDaysModal from "../Modal/ShiftBufferDaysModal";
import CreditLimitExchaustModal from "../Modal/CreditLimitExchaustModal";
import ShiftApprovalCreditLimitModal from "../Modal/ShiftApprovalCreditLimitModal";
import BranchInactiveAndCreditLimit from "../Modal/BranchInactiveAndCreditLimit";
import ShiftAndBranchActive from "../Modal/ShiftAndBranchActive";
import AllConditionsModal from "../Modal/AllCondtionsModal";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import ShiftCreditLimitAndBranch from "../Modal/ShiftCreditLimitAndBranch";
import ShiftCreditLimitAndDueDate from "../Modal/ShiftCreditLimitAndDueDate";
import ShiftBranchAndDueDate from "../Modal/ShiftBranchAndDueDate";
import CreditLimitBranchAndDueDate from "../Modal/CreditLimitBranchAndDueDate";
import ShiftAndDueDate from "../Modal/ShiftAndDueDate";
import CreditLimitAndDueDate from "../Modal/CreditLimitAndDueDate";
import BranchAndDueDate from "../Modal/BranchAndDueDate";
import PaymentDueDate from "../Modal/PaymentDueDate";
import {pushEvent} from "../../../utils/clevertap";

import "./ShiftManagement.scss";

const ShiftManagement = () => {
  let dispatch = useDispatch();
  const [professionalDetails, setProfessionalDetails] = useState({
    hospital: "",
    department: "",
    profession: "",
    qualification: "",
    specialization: "",
    experience: "",
    skillSet: [],
    hospitalName: "",
    departmentName: "",
    professionName: "",
    specializationName: "",
    qualificationName: "",
    experienceName: "",
  });
  const [jobEventPayload, setJobEventPayload] = useState([]);
  const [shiftConfig, setShiftConfig] = useState({
    shiftType: "single",
    professionalCount: "",
    rateOffered: "",
    campDuty: false,
    pocDetails: "",
    startDate: "",
    endDate: "",
    startTime: "",
    duration: "",
    recurringDays: [],
  });

  const [pocFacilities, setPocFacilities] = useState({
    pocDetails: "",
    isFood: false,
    isTransport: false,
    isAccommodation: false,
    others: "",
  });
  const [jobDescription, setJobDescription] = useState("");
  let [jobDescriptionList, setJobDescriptionList] = useState([]);
  const [isGenerating, setIsGenerating] = useState(false);
  const [isJobPostLoading, setJobPostLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleJobLimit, setVisibleJobLimit] = useState(false);
  const [creditLimitMessage, setCreditLimitMessage] = useState("");
  const [creditRemaining, setCreditRemaining] = useState(0);
  const [branchActivation, setBranchActivation] = useState(true);
  const [visibleBranchActivate, setVisibleBranchActivate] = useState(false);
  const [shiftApprovedBufferDays, setShiftApprovedBufferDays] = useState(false);
  const [visibleShiftApproval, setVisibleShiftApproval] = useState(false);
  const [finalTotalCreditLimit, setFinalTotalCreditLimit] = useState(0);
  const [visibleFinalTotalCreditLimit, setVisibleFinalTotalCreditLimit] =
    useState(false);
  const [shiftBufferDays, setShiftBufferDays] = useState("");
  const [pendingPaymentDues, setPendingPaymentDues] = useState(false);
  const [visiblePaymentDues, setVisiblePaymentDues] = useState(false);
  const [visibleShiftAndCreditLimit, setVisibleShiftAndCreditLimit] =
    useState(false);
  const [visibleBranchActivateAndCreditLimit, setVisibleBranchAndCreditLimit] =
    useState(false);
  const [visibleBranchAndShiftApproved, setVisibleBranchAndShiftApproved] =
    useState(false);
  const [
    visibleShiftCreditLimitBranchAndDueDate,
    setVisibleShiftCreditLimitBranchAndDueDate,
  ] = useState(false);
  const [paymentDueDatePending, setPaymentDueDatePending] = useState(false);
  const [pendingAmount, setPendingAmount] = useState(0);
  const [
    visibleShiftCreditLimitAndBranch,
    setVisibleShiftCreditLimitAndBranch,
  ] = useState(false);
  const [
    visibleShiftCreditLimitAndDueDate,
    setVisibleShiftCreditLimitAndDueDate,
  ] = useState(false);
  const [visibleShiftAndBranchAndDueDate, setVisibleShiftAndBranchAndDueDate] =
    useState(false);
  const [
    visibleCreditLimitBranchAndDueDate,
    setVisibleCreditLimitBranchAndDueDate,
  ] = useState(false);
  const [visibleShiftAndDueDate, setVisibleShiftAndDueDate] = useState(false);
  const [visibleCreditLimitAndDueDate, setVisibleCreditLimitAndDueDate] =
    useState(false);
  const [visibleBranchAndDueDate, setVisibleBranchAndDueDate] = useState(false);
  const [visiblePaymentDueDatePending, setVisiblePaymentDueDatePending] =
    useState(false);

  let [totalCost, setTotalCost] = useState({
    hospital: 0,
    margin: 0,
    gst: 0,
    total: 0,
  });
  const [minJobRate, setMinJobRate] = useState(0);
  const [minimumHour, setMinimumHour] = useState(0);
  const [maximumHour, setMaximumHour] = useState(0);

  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [navigationCallback, setNavigationCallback] = useState(null);
  const [clickCount, setClickCount] = useState(0);

  let navigate = useNavigate();
  const queryClient = useQueryClient();

  const generateShifts = useMutation({
    mutationFn: async () => {
      // console.log("here 2");
      // console.log("professionalDetails", professionalDetails);
      // console.log("shiftConfig", shiftConfig);

      // console.log("jobDescription", jobDescription);

      const multipleShifts = [];
      const singleShifts = [];
      // const finalShifts = [];

      if (shiftConfig?.shiftType === "multiple") {
        const startDate = new Date(shiftConfig.startDate);
        const endDate = new Date(shiftConfig.endDate);
        // console.log("startDate", startDate);
        // console.log("endDate", endDate);
        // const endTime = endDate.toTimeString().slice(0, 5);
        // console.log("endTime", endTime);

        const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

        for (
          let date = new Date(shiftConfig.startDate);
          date <= new Date(shiftConfig.endDate);
          date.setDate(date.getDate() + 1)
        ) {
          const dayOfWeek = dayMap[date.getDay()];
          const isRecurringEnabled =
            Array.isArray(shiftConfig.recurringDays) &&
            shiftConfig.recurringDays.length > 0;

          const shouldGenerateShift =
            !isRecurringEnabled ||
            shiftConfig.recurringDays.includes(dayOfWeek);

          if (shouldGenerateShift) {
            const [startHour, startMinute] = shiftConfig.startTime
              .split(":")
              .map(Number);
            const shiftStart = new Date(date);
            shiftStart.setHours(startHour, startMinute, 0, 0);

            const shiftEnd = new Date(
              shiftStart.getTime() + shiftConfig.duration * 60 * 60 * 1000
            );
            const endTime = shiftEnd.toTimeString().slice(0, 5);

            const formatIST = (date) => {
              const istDate = new Date(
                date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
              );
              const year = istDate.getFullYear();
              const month = String(istDate.getMonth() + 1).padStart(2, "0");
              const day = String(istDate.getDate()).padStart(2, "0");
              return `${year}-${month}-${day}`;
            };

            for (let i = 0; i < shiftConfig.professionalCount; i++) {
              multipleShifts.push({
                startDate: formatIST(shiftStart),
                endDate: formatIST(shiftEnd),
                startTime: shiftConfig.startTime,
                endTime: endTime,
                duration: shiftConfig.duration,
                rateOffered: shiftConfig.rateOffered,
                campDuty: shiftConfig.campDuty,
                recurringDays: shiftConfig.recurringDays,
                professionalCount: 1,
                hospital: professionalDetails.hospital,
                department: professionalDetails.department,
                profession: professionalDetails.profession,
                qualification: professionalDetails.qualification,
                specialization: professionalDetails.specialization,
                experience: professionalDetails.experience,
                jobDescription: jobDescription || "",
                hospitalName: professionalDetails.hospitalName,
                departmentName: professionalDetails.departmentName,
                professionName: professionalDetails.professionName,
                specializationName: professionalDetails.specializationName,
                qualificationName: professionalDetails.qualificationName,
                skillSet: professionalDetails?.skillSet || [],
                shiftType: "NON_CONSECUTIVE",
                pocDetails: pocFacilities?.pocDetails,
              });
            }
          }
        }

        // const dayMap = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]; // Sunday = 0

        // for (
        //   let date = new Date(startDate);
        //   date <= endDate;
        //   date.setDate(date.getDate() + 1)
        // ) {
        //   const dayOfWeek = dayMap[date.getDay()];
        //   let shouldGenerateShift = false;

        //   if (!shiftConfig.isRecurring) {
        //     // If recurring is disabled, generate shifts for every day in the range
        //     shouldGenerateShift = true;
        //   } else {
        //     // If recurring is enabled, generate shifts only for selected days
        //     shouldGenerateShift = shiftConfig.recurringDays.includes(dayOfWeek);
        //   }

        //   if (shouldGenerateShift) {
        //     const [startHour, startMinute] = shiftConfig.startTime
        //       .split(":")
        //       .map(Number);
        //     const shiftStart = new Date(date);
        //     shiftStart.setHours(startHour, startMinute, 0, 0);

        //     const shiftEnd = new Date(
        //       shiftStart.getTime() + shiftConfig.duration * 60 * 60 * 1000
        //     );
        //     const endTime = shiftEnd.toTimeString().slice(0, 5);

        //     for (let i = 0; i < shiftConfig.professionalCount; i++) {
        //       multipleShifts.push({
        //         startDate: date.toISOString().split("T")[0],
        //         endDate: date.toISOString().split("T")[0],
        //         startTime: shiftConfig.startTime,
        //         endTime: endTime,
        //         duration: shiftConfig.duration,
        //         rateOffered: shiftConfig.rateOffered,
        //         campDuty: shiftConfig.campDuty,
        //         // pocDetails: shiftConfig.pocDetails,
        //         recurringDays: shiftConfig.recurringDays,
        //         professionalCount: 1,
        //         hospital: professionalDetails.hospital,
        //         department: professionalDetails.department,
        //         profession: professionalDetails.profession,
        //         qualification: professionalDetails.qualification,
        //         specialization: professionalDetails.specialization,
        //         experience: professionalDetails.experience,
        //         jobDescription: jobDescription || "",
        //         hospitalName: professionalDetails.hospitalName,
        //         departmentName: professionalDetails.departmentName,
        //         professionName: professionalDetails.professionName,
        //         skillSet: professionalDetails.skillSet,
        //         shiftType: "NON_CONSECUTIVE",
        //         pocDetails: pocFacilities?.pocDetails,
        //       });
        //     }
        //   }
        // }

        // // console.log("multipleShifts", multipleShifts);
        // // return multipleShifts;
      }

      if (shiftConfig?.shiftType === "single") {
        // console.log("siftType1", shiftType);
        const shiftStart = new Date(
          `${shiftConfig?.startDate}T${shiftConfig?.startTime}:00`
        );
        // const shiftEnd = new Date(
        //   shiftStart.getTime() + shiftConfig?.duration * 60 * 60 * 1000
        // );
        const hours = Math.floor(shiftConfig?.duration); // e.g. 5.5 → 5
        const minutes = (shiftConfig?.duration - hours) * 60; // 0.5 → 30

        let shiftEnd = new Date(shiftStart);
        shiftEnd.setHours(shiftEnd.getHours() + hours);
        shiftEnd.setMinutes(shiftEnd.getMinutes() + minutes);

        console.log("shiftEnd", shiftEnd);

        const endDate = shiftEnd.toISOString().split("T")[0];
        const endTime = shiftEnd.toTimeString().slice(0, 5);
        console.log("endTime", endTime);
        // Format both start and end in IST
        const formatIST = (date) => {
          const istDate = new Date(
            date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
          );
          const year = istDate.getFullYear();
          const month = String(istDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based
          const day = String(istDate.getDate()).padStart(2, "0");
          return `${year}-${month}-${day}`;
        };

        // console.log("Start IST:", formatIST(shiftStart));
        // console.log("End   IST:", formatIST(shiftEnd));

        for (let i = 0; i < shiftConfig.professionalCount; i++) {
          singleShifts.push({
            startDate: shiftConfig.startDate,
            endDate: formatIST(shiftEnd),
            startTime: shiftConfig.startTime,
            endTime: endTime,
            duration: shiftConfig.duration,
            professionalCount: 1, // each shift is for 1 professional
            rateOffered: shiftConfig.rateOffered,
            campDuty: shiftConfig.campDuty,
            pocDetails: shiftConfig.pocDetails,
            hospital: professionalDetails.hospital,
            department: professionalDetails.department,
            profession: professionalDetails.profession,
            qualification: professionalDetails.qualification,
            specialization: professionalDetails.specialization,
            experience: professionalDetails.experience,
            jobDescription: jobDescription || "",
            recurringDays: shiftConfig.recurringDays,
            hospitalName: professionalDetails.hospitalName,
            departmentName: professionalDetails.departmentName,
            professionName: professionalDetails.professionName,
            qualificationName: professionalDetails.qualificationName,
            specializationName: professionalDetails.specializationName,
            skillSet: professionalDetails.skillSet,
            shiftType: "CONSECUTIVE",
            pocDetails: pocFacilities?.pocDetails,
          });
        }

        // return singleShifts;
      }

      console.log("singleShifts", singleShifts);

      const finalShifts = [...singleShifts, ...multipleShifts];

      return finalShifts;
    },

    onSuccess: (generatedShifts) => {
      console.log("Generated shifts (frontend only)", generatedShifts);
      queryClient.setQueryData(["/api/shifts"], (existing = []) => [
        ...existing,
        ...generatedShifts,
      ]);
    },

    // onSuccess: (generatedShifts) => {
    //   console.log("Generated shifts (frontend only)", generatedShifts);
    //   queryClient.setQueryData(["/api/shifts"], generatedShifts); // Store locally in cache
    // },
  });

  // Track form changes
  useEffect(() => {
    const isFormDirty =
      Object.values(professionalDetails).some(
        (val) => val !== "" && val !== null && val.length !== 0
      ) ||
      Object.values(shiftConfig).some(
        (val) => val !== "" && val !== null && val.length !== 0
      ) ||
      Object.values(pocFacilities).some(
        (val) => val !== "" && val !== null && val !== false
      ) ||
      jobDescription !== "";
    setHasUnsavedChanges(isFormDirty);
  }, [professionalDetails, shiftConfig, pocFacilities, jobDescription]);

  // Handle browser navigation
  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     if (hasUnsavedChanges) {
  //       event.preventDefault();
  //       event.returnValue =
  //         "You have unsaved changes. Are you sure you want to leave?";
  //     }
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, [hasUnsavedChanges]);

  function generateJobDescription() {
    if (clickCount >= 2) return;
    setClickCount((prev) => prev + 1);

    setIsGenerating(true); // Start loading

    const query = `
      query {
        withAuth(token: "${token}") {
          generateJD(
            profession: "${professionalDetails?.profession}",
            department: "${professionalDetails?.department}",
            experience: "${professionalDetails?.experience}",
            specialization: "${professionalDetails?.specialization}",
            qualification: "${professionalDetails?.qualification}"
          ) {
            jobDescription
          }
        }
      }
    `;

    graphqlRequest(query)
      .then((response) => {
        //  console.log("responseDescription>>", response);

        setJobDescription(
          response?.data?.withAuth?.generateJD?.jobDescription || ""
        );
      })
      .catch((err) => {
        console.error("JD generation failed:", err);
      })
      .finally(() => {
        setIsGenerating(false); // Stop loading
      });
  }

  function fetchMinjobRate() {
    let query = `
       query{
         withAuth(token:"${token}"){
           getMiniJobRate ( 
             branch:"${professionalDetails.hospital}" 
             department:"${professionalDetails.department}"
             profession:"${professionalDetails.profession}"
             qualification:"${professionalDetails.qualification}"
             specialization: "${professionalDetails.specialization}"
             experience: "${professionalDetails.experience}"
           )
          }
        }
         `;
    graphqlRequest(query).then((response) => {
      // console.log("2275-->", response);
      if (response.data.withAuth.getMiniJobRate) {
        setMinJobRate(response.data.withAuth.getMiniJobRate);
      }
    });
  }

  function fetchMinjobHour() {
    let query = `
     {
    withAuth(token:"${token}"){
     getProfessionalHour(profesionalId: "${professionalDetails.profession}"){
       id
      name
      minimumHour
      maximumHour
      }
    }
  }
         `;
    graphqlRequest(query).then((response) => {
      // console.log("professinalHour-->", response);
      if (response.data.withAuth.getProfessionalHour) {
        setMinimumHour(response.data.withAuth.getProfessionalHour.minimumHour);
        setMaximumHour(response.data.withAuth.getProfessionalHour.maximumHour);
      }
    });
  }

  let fetchJobDescription = () => {
    const query = `
    {
      withAuth(token: "${token}") {
        listJobDescription {
          profession
          experience
          specialization
          description
        }
      }
    }
    `;
    graphqlRequest(query).then((response) => {
      // console.log("jobDescriptionList", response.data.withAuth.listJobDescription);
      setJobDescriptionList(response.data.withAuth.listJobDescription);
    });
  };
  console.log("professionalDetailsInShift", professionalDetails);

  function fetchBranchDetails() {
    let query = `
     {
    withAuth(token:"${token}"){
      listMiniJobByBranchID(branchId: "${professionalDetails.hospital}") {
      shiftApprovedBufferDays
      paymentPendingDays
      branchActivate
      limit
      utilizedLimit
      shiftBufferDays
      exchaustUtilizedLimit
      paymentDueDatePending
      amountPending
      }
    }
  }
         `;
    graphqlRequest(query).then((response) => {
      console.log("listMiniJobByBranchID-->", response);
      setShiftBufferDays(
        response.data.withAuth.listMiniJobByBranchID.shiftBufferDays
      );
      if (response.data.withAuth.listMiniJobByBranchID) {
        let branchActive =
          response.data.withAuth.listMiniJobByBranchID.branchActivate;
        setBranchActivation(branchActive);

        let shiftApproved =
          response.data.withAuth.listMiniJobByBranchID.shiftApprovedBufferDays;
        setShiftApprovedBufferDays(shiftApproved);

        setFinalTotalCreditLimit(
          response.data.withAuth.listMiniJobByBranchID.limit
        );

        let paymentDues =
          response.data.withAuth.listMiniJobByBranchID.exchaustUtilizedLimit;
        setPendingPaymentDues(paymentDues);

        let paymentDueDatePendings =
          response.data.withAuth.listMiniJobByBranchID.paymentDueDatePending;
        setPaymentDueDatePending(paymentDueDatePendings);

        setPendingAmount(
          response.data.withAuth.listMiniJobByBranchID.amountPending
        );

        // if (
        //   shiftApproved === true &&
        //   paymentDues === true &&
        //   branchActive === false &&
        //   paymentDueDatePendings === true
        // ) {
        //   setVisibleShiftCreditLimitAndBranch(true);
        // } else if (shiftApproved === true && paymentDues === true) {
        //   setVisibleShiftAndCreditLimit(true);
        // } else if (branchActive === false && shiftApproved === true) {
        //   setVisibleBranchAndShiftApproved(true);
        // } else if (branchActive === false && paymentDues === true) {
        //   setVisibleBranchAndCreditLimit(true);
        // } else if (branchActive === false && !visibleBranchActivate) {
        //   setVisibleBranchActivate(true);
        // } else if (shiftApproved === true) {
        //   setVisibleShiftApproval(true);
        // } else if (paymentDues === true) {
        //   {
        //     setVisiblePaymentDues(true);
        //   }
        // }

        console.log(
          "beforeModal",
          shiftApproved,
          paymentDues,
          branchActive,
          paymentDueDatePendings
        );
        if (
          shiftApproved === true &&
          paymentDues === true &&
          branchActive === false &&
          paymentDueDatePendings === true
        ) {
          setVisibleShiftCreditLimitBranchAndDueDate(true);
        } else if (
          shiftApproved === true &&
          paymentDues === true &&
          branchActive === false
        ) {
          setVisibleShiftCreditLimitAndBranch(true);
        } else if (
          shiftApproved === true &&
          paymentDues === true &&
          paymentDueDatePendings === true
        ) {
         
          setVisibleShiftCreditLimitAndDueDate(true);
        } else if (
          shiftApproved === true &&
          branchActive === false &&
          paymentDueDatePendings === true
        ) {
          setVisibleShiftAndBranchAndDueDate(true);
        } else if (
          paymentDues === true &&
          branchActive === false &&
          paymentDueDatePendings === true
        ) {
          setVisibleCreditLimitBranchAndDueDate(true);
        } else if (shiftApproved === true && paymentDues === true) {
          setVisibleShiftAndCreditLimit(true);
        } else if (shiftApproved === true && branchActive === false) {
          setVisibleBranchAndShiftApproved(true);
        } else if (shiftApproved === true && paymentDueDatePendings === true) {
          setVisibleShiftAndDueDate(true);
        } else if (paymentDues === true && branchActive === false) {
          setVisibleBranchAndCreditLimit(true);
        } else if (paymentDues === true && paymentDueDatePendings === true) {
          setVisibleCreditLimitAndDueDate(true);
        } else if (branchActive === false && paymentDueDatePendings === true) {
          setVisibleBranchAndDueDate(true);
        } else if (shiftApproved === true) {
          setVisibleShiftApproval(true);
        } else if (paymentDues === true) {
          setVisiblePaymentDues(true);
        } else if (branchActive === false && !visibleBranchActivate) {
          setVisibleBranchActivate(true);
        } else if (paymentDueDatePendings === true) {
          setVisiblePaymentDueDatePending(true);
        }
      }
    });
  }

  let setmyJobDescription = () => {
    let filterJobDescription = [];
    // console.log("inside des professionalDetails", professionalDetails);
    filterJobDescription = jobDescriptionList?.filter((data) => {
      if (
        data.experience.toLowerCase() ===
          professionalDetails.experienceName.toLowerCase() &&
        data.specialization.toLowerCase() ===
          professionalDetails.specializationName.toLowerCase() &&
        data.profession === professionalDetails.professionName
      ) {
        return data;
      }
    });

    // console.log("filterJobDescription", filterJobDescription);
    if (filterJobDescription.length > 0) {
      setJobDescription(filterJobDescription?.[0]?.description);
    } else {
      setJobDescription("");
    }
    // filterJobDescription.length > 0 &&
    //   setJobDescription(filterJobDescription?.[0]?.description);
  };

  const handleGenerateShifts = () => {
    // console.log("here 1");
    // console.log("generateShifts", generateShifts);
    // const duration = parseInt(shiftConfig.duration);
    const duration = parseFloat(shiftConfig.duration);

    if (
      !professionalDetails.profession ||
      !professionalDetails.department ||
      !professionalDetails.hospital ||
      !professionalDetails.qualification ||
      !professionalDetails.specialization ||
      !professionalDetails.experience
    ) {
      message.error(
        "Please fill professional details before generating shifts."
      );
      return;
    }

    if (!shiftConfig.professionalCount) {
      message.error("Please provide number of professionals.");
      return;
    }

    if (shiftConfig.rateOffered < minJobRate) {
      message.error(
        `Rate Offered Per Hour must be greater than ₹${minJobRate}.`
      );
      return;
    }

    if (
      !shiftConfig.startDate ||
      !shiftConfig.startTime ||
      (shiftConfig.shiftType === "multiple" && !shiftConfig.endDate)
    ) {
      // alert("Please fill in required dates");
      message.error("Please fill in required date and time.");
      return;
    }

    if (isNaN(duration) || duration < minimumHour || duration > maximumHour) {
      message.error(
        `Duration must be between ${minimumHour} and ${maximumHour} hours.`
      );
      return;
    }

    const selectedDate = new Date(shiftConfig.startDate);
    const [hours, minutes] = shiftConfig.startTime.split(":");
    selectedDate.setHours(Number(hours));
    selectedDate.setMinutes(Number(minutes));
    selectedDate.setSeconds(0);

    const now = new Date();

    if (selectedDate < now) {
      message.error("Select time");
      return;
    }

    // console.log("here 2");
    generateShifts.mutate();
  };

  const handleRepostJob = (jobData) => {
    // console.log("jobData in shift management", jobData);
    // console.log("shiftConfig", jobData.shiftConfig);
    // console.log("professionalDetails->", jobData.professionalDetails);
    pushEvent("Web_Repost_Job ", {
      page: "JOB POST",
      section: "Jobs",
      professionalDetails: jobData.professionalDetails,
      shiftConfig:jobData.shiftConfig,
      pocFacilities :jobData.pocFacilities

    });
    setProfessionalDetails(jobData.professionalDetails);
    setShiftConfig(jobData.shiftConfig);
    setJobDescription(jobData.jobDescription);
    setPocFacilities(jobData.pocFacilities);
  };

  const handleAISuggestions = (suggestions) => {
    if (suggestions.hospital)
      setProfessionalDetails((prev) => ({
        ...prev,
        hospital: suggestions.hospital,
      }));
    if (suggestions.department)
      setProfessionalDetails((prev) => ({
        ...prev,
        department: suggestions.department,
      }));
    if (suggestions.profession)
      setProfessionalDetails((prev) => ({
        ...prev,
        profession: suggestions.profession,
      }));
    if (suggestions.qualification)
      setProfessionalDetails((prev) => ({
        ...prev,
        qualification: suggestions.qualification,
      }));
    if (suggestions.specialization)
      setProfessionalDetails((prev) => ({
        ...prev,
        specialization: suggestions.specialization,
      }));
    if (suggestions.experience)
      setProfessionalDetails((prev) => ({
        ...prev,
        experience: suggestions.experience,
      }));

    if (suggestions.professionalCount)
      setShiftConfig((prev) => ({
        ...prev,
        professionalCount: suggestions.professionalCount,
      }));
    if (suggestions.rateOffered)
      setShiftConfig((prev) => ({
        ...prev,
        rateOffered: suggestions.rateOffered,
      }));
    if (suggestions.campDuty !== undefined)
      setShiftConfig((prev) => ({ ...prev, campDuty: suggestions.campDuty }));
    if (suggestions.startDate)
      setShiftConfig((prev) => ({ ...prev, startDate: suggestions.startDate }));
    if (suggestions.endDate)
      setShiftConfig((prev) => ({ ...prev, endDate: suggestions.endDate }));
    if (suggestions.startTime)
      setShiftConfig((prev) => ({ ...prev, startTime: suggestions.startTime }));
    if (suggestions.duration)
      setShiftConfig((prev) => ({ ...prev, duration: suggestions.duration }));
    if (suggestions.shiftType)
      setShiftConfig((prev) => ({ ...prev, shiftType: suggestions.shiftType }));
    if (suggestions.recurringDays)
      setShiftConfig((prev) => ({
        ...prev,
        recurringDays: suggestions.recurringDays,
      }));
    if (suggestions.pocDetails)
      setShiftConfig((prev) => ({
        ...prev,
        pocDetails: suggestions.pocDetails,
      }));

    if (suggestions.jobDescription)
      setJobDescription(suggestions.jobDescription);
  };

  // console.log("generateShifts", generateShifts.data);
  const { data: shifts = [], isLoading } = useQuery({
    queryKey: ["/api/shifts"],
    queryFn: async () => {
      const response = await fetch("/api/shifts");
      if (!response.ok) throw new Error("Failed to fetch shifts");
      return response.json();
    },
  });

  console.log("generateShifts22", shifts);

  // let finalShifts = generateShifts
  const groupShiftsIntoJobs = (shifts) => {
    // console.log("shifts", shifts);
    const jobsMap = new Map();

    for (const shift of shifts) {
      // console.log("shift", shift);
      const jobKey = `${shift.startDate}-${shift.startTime}-${shift.endDate}-${shift.endTime}-${shift.campDuty}-${shift.rateOffered}`;

      // console.log("jobKey", jobKey);
      if (!jobsMap.has(jobKey)) {
        // First time seeing this key, add the shift
        jobsMap.set(jobKey, {
          ...shift,
          professionalCount: shift.professionalCount, // start with current count
          groupedShifts: [shift],
        });
      } else {
        // Already exists, merge shift
        const job = jobsMap.get(jobKey);
        job.groupedShifts.push(shift);
        job.professionalCount += shift.professionalCount; // increment count
      }
    }

    // Return grouped job array (optional: remove groupedShifts key if not needed)
    return Array.from(jobsMap.values()).map((job) => {
      delete job.groupedShifts; // if you don't want to return internal shifts
      return job;
    });
  };

  let loginData = localStorage.getItem("auth");
  let token = JSON.parse(loginData)?.accessToken;

  const convertToTimeObject = (dt) => {
    // console.log("dt", dt);
    const dateObj = new Date(dt);
    if (isNaN(dateObj.getTime())) {
      throw new Error(`Invalid Date: ${dt}`);
    }

    return {
      year: dateObj.getFullYear(),
      month: dateObj.getMonth() + 1,
      date: dateObj.getDate(),
      hour: dateObj.getHours(),
      min: dateObj.getMinutes(),
      sec: dateObj.getSeconds(),
      millis: dateObj.getMilliseconds(),
      tz: "-330",
      ts: dateObj.getTime().toString(),
      datetime: dateObj.toISOString(),
    };
  };

  function convertTimingToDBStructure(timing) {
    // console.log("timing", timing);
    // console.log(
    //   "${timing.startDate}T${timing.startTime}`",
    //   `${timing.start}T${timing.startTime}`
    // );
    const shiftStart = new Date(`${timing.start}T${timing.startTime}`);
    const shiftEnd = new Date(`${timing.end}T${timing.endTime}`);

    // console.log("shiftStart", shiftStart);
    if (timing.type === "CONSECUTIVE") {
      return {
        consequtiveTime: {
          start: convertToTimeObject(shiftStart),
          end: convertToTimeObject(shiftEnd),
        },
      };
    } else if (timing.type === "NON_CONSECUTIVE") {
      return {
        nonConsequtiveTime: {
          start: convertToTimeObject(shiftStart),
          end: convertToTimeObject(shiftEnd),
          weekdays: timing.weekdays || [],
        },
      };
    } else {
      throw new Error("Invalid shift type");
    }
  }

  function randomNumBetween3And5() {
    const nums = [3, 4, 5];
    const randomIndex = Math.floor(Math.random() * nums.length);
    return nums[randomIndex];
  }
  function addRating(arr) {
    return arr.map((obj) => ({ ...obj, rating: randomNumBetween3And5() }));
  }
  function convertToWeekName(weekdays) {
    let result = weekdays.map((data) => {
      if (data === "Sun") {
        return "SUNDAY";
      }
      if (data === "Mon") {
        return "MONDAY";
      }
      if (data === "Tue") {
        return "TUESDAY";
      }
      if (data === "Wed") {
        return "WEDNESDAY";
      }
      if (data === "Thu") {
        return "THURSDAY";
      }
      if (data === "Fri") {
        return "FRIDAY";
      }
      if (data === "Sat") {
        return "SATURDAY";
      }
    });

    return result;
  }

  // console.log("shifts above postLocum", shifts);
  // console.log("pocFacilities", pocFacilities);

  // const PostLocumJob = async () => {
  //   const groupedJobs = await groupShiftsIntoJobs(shifts || []);
  //   console.log("Grouped Jobs:", groupedJobs);
  //   console.log("groupedJobs", groupedJobs.length);

  //   const jobPromises = groupedJobs.map(async (job) => {
  //     const pocDetails = pocFacilities?.pocDetails || "";
  //     const name = pocDetails.split(" (")[0];
  //     const email = pocDetails.match(/\(([^)]+)\)/)?.[1] || "";
  //     const contact = pocDetails.split(") ")[1] || "";

  //     const food =
  //       pocFacilities?.isFood === undefined ? false : pocFacilities?.isFood;
  //     const transport =
  //       pocFacilities?.isTransport === undefined
  //         ? false
  //         : pocFacilities?.isTransport;
  //     let additionalSkillsString = JSON.stringify(job.skillSet);

  //     const query = `
  //     mutation postMiniJobV1($JD: String!) {
  //       mutationWithAuth(token: "${token}") {
  //         fabricate {
  //           postMiniJobV1(
  //             branch: "${job.hospital}"
  //             department: "${job.department}"
  //             profession: "${job.profession}"
  //             qualification: "${job.qualification}"
  //             specialization: "${job.specialization}"
  //             experience: "${job.experience}"
  //             additionalSkill: ${additionalSkillsString},
  //             maxRate: ${job.rateOffered}
  //             applicants: ${job.professionalCount}
  //             duration: ${job.duration}
  //             description: $JD
  //             timing: {
  //               type: ${job.shiftType},
  //               start: "${job.startDate}",
  //               end: "${job.endDate}",
  //               weekdays: [${convertToWeekName(job.recurringDays)}],
  //               startTime: "${job.startTime}",
  //               endTime: "${job.endTime}"
  //             }
  //             isFood: ${food},
  //             isAccommodation: false,
  //             isTransport: ${transport},
  //             others: "${pocFacilities?.others}",
  //             campDuty: ${job.campDuty},
  //             contact: {
  //               contactPerson: "${name}"
  //               email: "${email}"
  //               phone: "${contact}"
  //             }
  //           ) {
  //             id
  //             code
  //             state
  //           }
  //         }
  //       }
  //     }
  //   `;

  //     console.log("query", query);
  //     try {
  //       const response = await graphqlRequest(query, {
  //         JD: jobDescription,
  //       });
  //       console.log("response", response);
  //       const result =
  //         response?.data?.mutationWithAuth?.fabricate?.postMiniJobV1;
  //       console.log("result", result);
  //       if (
  //         result?.errors?.[0]?.message ===
  //         "Time already passed!! Enter correct time"
  //       ) {
  //         return {
  //           success: false,
  //           error: "Time already passed!! Enter correct time",
  //         };
  //       }
  //       if (
  //         result?.errors?.[0]?.message ===
  //         "Please enter correct start and end time"
  //       ) {
  //         return {
  //           success: false,
  //           error: "Please enter correct start and end time",
  //         };
  //       }
  //       if (result?.errors?.length > 0) {
  //         return {
  //           success: false,
  //           error: result.errors[0].message || "Something went wrong!",
  //         };
  //       }

  //       if (result) {
  //         // log success and analytics
  //         dispatch(setUserJobPost(result));
  //         // getRecommendedUser(result.id);
  //         return { success: true, job: result };
  //       }

  //       // else {
  //       //   const errorMessage =
  //       //     response?.errors?.[0]?.message || "Unknown error";
  //       //   return { success: false, error: errorMessage };
  //       // }
  //     } catch (err) {
  //       console.error("Job creation failed:", err);
  //       return { success: false, error: err.message || "Network error" };
  //     }
  //   });

  //   setJobPostLoading(true);

  //   const jobResults = await Promise.all(jobPromises);
  //   setJobPostLoading(false);

  //   console.log("jobResults", jobResults);
  //   const successJobs = jobResults.filter((res) => res.success);
  //   const failedJobs = jobResults.filter((res) => !res.success);

  //   console.log("successJobs", successJobs);
  //   if (successJobs.length > 0) {
  //     dispatch(setUserJobPostArray(successJobs));
  //     getRecommendedUser(successJobs[0]?.job?.id);
  //     message.success("Job Post Done");
  //     queryClient.removeQueries(["/api/shifts"]);

  //     // message.success(`${successJobs.length} Job(s) Posted Successfully`);
  //     window.dataLayer.push({
  //       event: "purchase",
  //       department: professionalDetails?.department,
  //       profession: professionalDetails?.profession,
  //       qualification: professionalDetails?.qualification,
  //       experience: professionalDetails?.experience,
  //       professional_charges: totalCost?.hospital,
  //     });
  //   }

  //   console.log("failedJobs", failedJobs);
  //   if (failedJobs.length > 0) {
  //     message.error(`${failedJobs.length} Job(s) Failed`);
  //     const creditLimitErrors = failedJobs.find((f) =>
  //       f.error.includes("Credit limit exceeded")
  //     );
  //     const rateErrors = failedJobs.find((f) =>
  //       f.error.includes("No object found for Rate")
  //     );

  //     if (creditLimitErrors) {
  //       setJobPostLoading(false);
  //       // if (response.errors[0].message === "Credit limit exceeded!") {
  //       //   // message.error("Credit Limit Exceeded, Please pay pending bills to use further!");
  //       //   setVisible(true);
  //       // }
  //       setVisible(true);
  //     } else if (rateErrors) {
  //       message.error("Please check minimum Rate for posting");
  //     } else {
  //       // message.error("Some jobs failed to post. Please retry.");
  //       message.error(failedJobs[0].error);
  //     }
  //   }
  // };

  const handleOk = () => {
    setVisible(false);
  };

  const handleJobLimit = () => {
    setVisibleJobLimit(false);
    setCreditRemaining(0);
  };

  const handleShiftApprovedCreditAndBranch = () => {
    // setVisibleShiftCreditLimitAndBranch(false);
    setVisibleShiftCreditLimitBranchAndDueDate(false);
  };

  const handleShiftCreditLimitAndBranch = () => {
    // setVisibleShiftCreditLimitAndBranch(false);
    setVisibleShiftCreditLimitAndBranch(false);
  };

  const handleShiftCreditLimitAndDueDate = () => {
    // setVisibleShiftCreditLimitAndBranch(false);
    setVisibleShiftCreditLimitAndDueDate(false);
  };

  const handleShiftAndBranchAndDueDate = () => {
    // setVisibleShiftCreditLimitAndBranch(false);
    setVisibleShiftAndBranchAndDueDate(false);
  };

  const handleCreditLimitBranchAndDueDate = () => {
    // setVisibleShiftCreditLimitAndBranch(false);
    setVisibleCreditLimitBranchAndDueDate(false);
  };

  const handleShiftAndCreditLimit = () => {
    setVisibleShiftAndCreditLimit(false);
    // setPendingPaymentDues(true);
  };

  const handleBranchAndShiftApproved = () => {
    setVisibleBranchAndShiftApproved(false);
  };

  const handleShiftAndDueDate = () => {
    setVisibleShiftAndDueDate(false);
  };

  const handleBranchAndCreditLimit = () => {
    setVisibleBranchAndCreditLimit(false);
  };

  const handleCreditLimitAndDueDate = () => {
    setVisibleCreditLimitAndDueDate(false);
  };

  const handleBranchAndDueDate = () => {
    setVisibleBranchAndDueDate(false);
  };

  const handleShiftApproval = () => {
    setVisibleShiftApproval(false);
    setShiftApprovedBufferDays(true);
  };

  const handleFinalCreditLimit = () => {
    // setVisibleFinalTotalCreditLimit(false);
    // setFinalTotalCreditLimit(0);
    setVisiblePaymentDues(false);
    setPendingPaymentDues(true);
  };

  const handleBranchActivate = () => {
    setVisibleBranchActivate(false);
    setBranchActivation(false);
  };

    const handleVisibleDueDate = () => {
      setVisiblePaymentDueDatePending(false);
    };

  const handleOnReview = () => {
    navigate("/locum/shift-logs");
  };

  const handleOnBilling = () => {
    navigate("/billing");
  };

  console.log("professionalDetailsFInal", professionalDetails);
  console.log("finaltotalCost", totalCost);

  const PostLocumJob = async () => {
    const groupedJobs = await groupShiftsIntoJobs(shifts || []);
    const eventPayloadArray = [];
    console.log("Grouped Jobs:", groupedJobs);

    const now = new Date();

    // Check for any invalid job times
    const hasPastJob = groupedJobs.some((job) => {
      const jobDate = new Date(job.startDate);
      const [hour, minute] = job.startTime.split(":").map(Number);
      jobDate.setHours(hour, minute, 0, 0);
      return jobDate < now;
    });

    if (hasPastJob) {
      message.error(
        "One or more shifts have start time in the past. Please correct them."
      );
      return;
    }
    const finalTotalCost =
      professionalDetails?.utilizedLimit + totalCost?.total;
    const creditLimit = professionalDetails?.creditLimit;
    console.log("creditLimit", creditLimit);
    console.log("finalTotalCostAfterAdded", finalTotalCost);
    console.log("creditThrosold", professionalDetails?.creditThresholdPercent);
    console.log("branchActivation", branchActivation);

    // if (
    //   shiftApprovedBufferDays === true &&
    //   pendingPaymentDues === true &&
    //   branchActivation === false
    // ) {
    //   setVisibleShiftCreditLimitAndBranch(true);
    //   return;
    // } else if (
    //   shiftApprovedBufferDays === true &&
    //   pendingPaymentDues === true
    // ) {
    //   setVisibleShiftAndCreditLimit(true);
    //   return;
    // } else if (branchActivation === false && shiftApprovedBufferDays === true) {
    //   setVisibleBranchAndShiftApproved(true);
    //   return;
    // } else if (branchActivation === false && pendingPaymentDues === true) {
    //   setVisibleBranchAndCreditLimit(true);
    //   return;
    // } else if (branchActivation === false) {
    //   setVisibleBranchActivate(true);
    //   return;
    // } else if (shiftApprovedBufferDays === true) {
    //   setVisibleShiftApproval(true);
    //   return;
    // } else if (pendingPaymentDues === true) {
    //   setVisiblePaymentDues(true);
    //   return;
    // }
     if (
       shiftApprovedBufferDays === true &&
       pendingPaymentDues === true &&
       branchActivation === false &&
       paymentDueDatePending === true
     ) {
       setVisibleShiftCreditLimitBranchAndDueDate(true);
       return;
     } else if (
       shiftApprovedBufferDays === true &&
       pendingPaymentDues === true &&
       branchActivation === false
     ) {
       setVisibleShiftCreditLimitAndBranch(true);
       return;
     } else if (
       shiftApprovedBufferDays === true &&
       pendingPaymentDues === true &&
       paymentDueDatePending === true
     ) {
       setVisibleShiftCreditLimitAndDueDate(true);
       return;
     } else if (
       shiftApprovedBufferDays === true &&
       branchActivation === false &&
       paymentDueDatePending === true
     ) {
       setVisibleShiftAndBranchAndDueDate(true);
       return;
     } else if (
       pendingPaymentDues === true &&
       branchActivation === false &&
       paymentDueDatePending === true
     ) {
       setVisibleCreditLimitBranchAndDueDate(true);
       return;
     } else if (shiftApprovedBufferDays === true && pendingPaymentDues === true) {
       setVisibleShiftAndCreditLimit(true);
       return;
     } else if (shiftApprovedBufferDays === true && branchActivation === false) {
       setVisibleBranchAndShiftApproved(true);
       return;
     } else if (shiftApprovedBufferDays === true && paymentDueDatePending === true) {
       setVisibleShiftAndDueDate(true);
       return true
     } else if (pendingPaymentDues === true && branchActivation === false) {
       setVisibleBranchAndCreditLimit(true);
       return;
     } else if (pendingPaymentDues === true && paymentDueDatePending === true) {
       setVisibleCreditLimitAndDueDate(true);
       return;
     } else if (branchActivation === false && paymentDueDatePending === true) {
       setVisibleBranchAndDueDate(true);
       return;
     } else if (shiftApprovedBufferDays === true) {
       setVisibleShiftApproval(true);
       return;
     } else if (pendingPaymentDues === true) {
       setVisiblePaymentDues(true);
       return;
     } else if (branchActivation === false) {
       setVisibleBranchActivate(true);
       return;
     } else if (paymentDueDatePending === true) {
       setVisiblePaymentDueDatePending(true);
       return
     }

    // if (finalTotalCost > finalTotalCreditLimit) {
    //   setVisibleFinalTotalCreditLimit(true);
    //   return;
    // }

    const totalLimit =
      professionalDetails?.creditLimit +
      professionalDetails?.creditLimit *
        (professionalDetails?.creditThresholdPercent / 100);

    // if (finalTotalCost > creditLimit) {
    if (finalTotalCost > totalLimit) {
      const remainingCredit = creditLimit - professionalDetails?.utilizedLimit;
      // let actualRemainingCredit = remainingCredit <= 0 ? 0 : remainingCredit;
      const actualRemainingCredit = Math.max(0, remainingCredit);
      setCreditRemaining(actualRemainingCredit);
      setVisibleJobLimit(true);
      return;
    }
    const jobPromises = groupedJobs.map(async (job) => {
      const pocDetails = pocFacilities?.pocDetails || "";
      const name = pocDetails.split(" (")[0];
      const email = pocDetails.match(/\(([^)]+)\)/)?.[1] || "";
      const contact = pocDetails.split(") ")[1] || "";

      const food = pocFacilities?.isFood ?? false;
      const transport = pocFacilities?.isTransport ?? false;
      const accomodation = pocFacilities?.isAccommodation ?? false;
      const additionalSkillsString = JSON.stringify(job.skillSet);
      const jobPayload = {
        branch: job.hospitalName,
        department: job.departmentName,
        profession: job.professionName,
        qualification: job.qualificationName,
        specialization: job.specializationName,
        experience: job.experienceName,
        maxRate: job.rateOffered,
        applicants: job.professionalCount,
        duration: job.duration,
        description: jobDescription,
        shiftType: job.shiftType,
        startDate: job.startDate,
        endDate: job.endDate,
        weekdays: convertToWeekName(job.recurringDays),
        startTime: job.startTime,
        endTime: job.endTime,
        food: food,
        transport:transport,
        accomodation:accomodation,
        others: pocFacilities?.others,
        campDuty: job.campDuty,
        contactPerson: name,
        email: email,
        phone: contact,
      };
      
      eventPayloadArray.push(jobPayload);

      const query = `
      mutation postMiniJobV1($JD: String!) {
        mutationWithAuth(token: "${token}") {
          fabricate {
            postMiniJobV1(
              branch: "${job.hospital}"
              department: "${job.department}"
              profession: "${job.profession}"
              qualification: "${job.qualification}"
              specialization: "${job.specialization}"
              experience: "${job.experience}"
              additionalSkill: ${additionalSkillsString},
              maxRate: ${job.rateOffered}
              applicants: ${job.professionalCount}
              duration: ${job.duration}
              description: $JD
              timing: {
                type: ${job.shiftType},
                start: "${job.startDate}",
                end: "${job.endDate}",
                weekdays: [${convertToWeekName(job.recurringDays)}],
                startTime: "${job.startTime}",
                endTime: "${job.endTime}"
              }
              isFood: ${food},
              isAccommodation: ${accomodation},
              isTransport: ${transport},
              others: "${pocFacilities?.others}",
              campDuty: ${job.campDuty},
              contact: {
                contactPerson: "${name}"
                email: "${email}"
                phone: "${contact}"
              }
            ) {
              id
              code
              state
              createdAt
            }
          }
        }
      }
    `;

      console.log("queryData", query);
      try {
        const response = await graphqlRequest(query, { JD: jobDescription });
        console.log("response222", response);
        // if (response.errors[0].message === "Credit limit exceeded!") {
        //   //  console.log("Credit limit exceeded!");
        //   setVisible(true);
        // }
        const result =
          response?.data?.mutationWithAuth?.fabricate?.postMiniJobV1;

        console.log("result111", result);
        const errorMessage =
          response?.errors?.[0]?.message ||
          result?.errors?.[0]?.message ||
          null;

        if (errorMessage) {
          if (errorMessage === "Credit limit exceeded!") {
            setVisible(true);
          }
          return {
            success: false,
            error: errorMessage,
            // response222,
          };
        }

        console.log("result22", result);
        if (result?.id) {
          return {
            success: true,
            job: result,
          };
        }

        return {
          success: false,
          error: result?.errors?.[0]?.message,
        };
      } catch (err) {
        console.error("Job creation failed:", err);
        return {
          success: false,
          error: err.message || "Network error",
        };
      }
    });

    setJobPostLoading(true);
    const jobResults = await Promise.all(jobPromises);
    setJobPostLoading(false);

    console.log("jobResults", jobResults);
    const successJobs = jobResults.filter((res) => res.success);
    const failedJobs = jobResults.filter((res) => !res.success);
    console.log("failedJobs", failedJobs);
    // ❌ Abort all if any failed
    if (failedJobs.length > 0) {
      console.log("❌ Some jobs failed. No jobs will be posted.");
      message.error(`${failedJobs.length} Job(s) Failed`);
      const firstError = failedJobs[0].error;

      const creditLimitErrors = failedJobs.find((f) =>
        f.error.includes("Credit limit exceeded")
      );
      const rateErrors = failedJobs.find((f) =>
        f.error.includes("No object found for Rate")
      );

      if (creditLimitErrors) {
        setVisible(true);
      } else if (rateErrors) {
        message.error("Please check minimum Rate for posting");
      } else {
        message.error(firstError);
      }

      return {
        success: false,
        errors: failedJobs.map((e) => e.error),
      };
    }
    setJobEventPayload(eventPayloadArray);

    pushEvent("Web_Locum_Job_Posted", {
      // page: "JOB POST",
      // section: "Jobs",
      "Job Id": successJobs[0]?.job?.code,
      "Job Created At": successJobs[0]?.job?.createdAt
      ? new Date(Number(successJobs[0]?.job?.createdAt)).toISOString().split("T")[0]
      : null,
      Branch: eventPayloadArray[0]?.branch,
      department: eventPayloadArray[0]?.department,
      profession: eventPayloadArray[0]?.profession,
      specialization: eventPayloadArray[0]?.specialization,
      maxRate: eventPayloadArray[0]?.maxRate,
      applicants: eventPayloadArray[0]?.applicants,
      hours: eventPayloadArray[0]?.duration,
      shiftType: eventPayloadArray[0]?.description,
      startDate: eventPayloadArray[0]?.startDate,
      startTime: eventPayloadArray[0]?.startTime,
      endDate: eventPayloadArray[0]?.endDate,
      endTime: eventPayloadArray[0]?.endTime,
      campDuty: eventPayloadArray[0]?.campDuty ? "Yes" : "No",
      Description: eventPayloadArray[0]?.description , 
      contactPerson: eventPayloadArray[0]?.contactPerson,

    });
    
    // ✅ Proceed if all jobs succeed
    dispatch(setUserJobPostArray(successJobs));
    getRecommendedUser(successJobs[0]?.job?.id);
    message.success("All Jobs Posted Successfully");

    window.dataLayer.push({
      event: "purchase",
      department: professionalDetails?.department,
      profession: professionalDetails?.profession,
      qualification: professionalDetails?.qualification,
      experience: professionalDetails?.experience,
      professional_charges: totalCost?.hospital,
    });

    queryClient.removeQueries(["/api/shifts"]);
    setHasUnsavedChanges(false);

    return {
      success: true,
      jobs: successJobs.map((j) => j.job),
    };
  };

  function getRecommendedUser(jobId) {
    let query = `
      {
        getRecommendedUser(jobId:"${jobId}") {
          absoluteMatch {
            id
            marksPercentage
            avatar {
              url
            }
            emails {
              isPrimary
              address
            }
            phoneNumbers {
              isPrimary
              number
            }
            name {
              full
            }
            address {
              state
              address
              country
              city
              country
              pin
            }
            specialization {
              name
              id
            }
            numExperience {
              id
              name
            }
            workCity {
              id
              name
            }
            qualification {
              id
              name
            }
            professionalType {
              id
              name
            }
            profile {
              dob
              gender
              pan
              aadhar
              social {
                facebook
                linkedin
              }
              covid
              jobHistory {
                hospital
                department
                specialisation
                start
                end
              }
              education {
                course
                specialisation
                name
                year
              }
              references {
                name
                hospital
                designation
                phone
                email
              }
            }
            languageKnownNew
            additionalTrainingNew
            workedOn {
              id
              softwarename
            }
            professionalRegistration {
              number
              registrationType {
                id
                name
              }
            }
            avatar {
              location
              fileName
              uri
              bucket
              region
              mimeType
              secureUrl
              url
              isSecured
              cdnUrl
            }
            correspondenceAddress {
              address
              city
              state
              pin
              country
            }
            departments {
              id
              name
            }
            averageRating
            numberOfRatings
          }
          similarMatch {
            id
            marksPercentage
            avatar {
              url
            }
            emails {
              isPrimary
              address
            }
            phoneNumbers {
              isPrimary
              number
            }
            name {
              full
            }
            address {
              state
              address
              country
              city
              country
              pin
            }
            specialization {
              name
              id
            }
            numExperience {
              id
              name
            }
            workCity {
              id
              name
            }
            qualification {
              id
              name
            }
            professionalType {
              id
              name
            }
            profile {
              dob
              gender
              pan
              aadhar
              social {
                facebook
                linkedin
              }
              covid
              jobHistory {
                hospital
                department
                specialisation
                start
                end
              }
              education {
                course
                specialisation
                name
                year
              }
              references {
                name
                hospital
                designation
                phone
                email
              }
            }
            languageKnownNew
            additionalTrainingNew
            workedOn {
              id
              softwarename
            }
            professionalRegistration {
              number
              registrationType {
                id
                name
              }
            }
            avatar {
              location
              fileName
              uri
              bucket
              region
              mimeType
              secureUrl
              url
              isSecured
              cdnUrl
            }
            correspondenceAddress {
              address
              city
              state
              pin
              country
            }
            departments {
              id
              name
            }
            averageRating
            numberOfRatings
          }
        }
    }
      `;
    graphqlRequest(query, {}).then((response) => {
      // console.log("1-->", response.data.getRecommendedUser);
      // setRecommendedUser(response.data.getRecommendedUser);
      if (response.data.getRecommendedUser.similarMatch.length === 0) {
        // dispatch(setRecommendedUsers(profile));
        // dispatch(setOpenJobMatches());
        dispatch(
          setActiveTab({ index: 3, locumActive: 1, LocumJobToggle: true })
        );
        navigate("/locum/open-jobs");
      } else {
        dispatch(
          // setRecommendedUsers(addRating(response.data.getRecommendedUser)),
          setRecommendedUsers(
            addRating(response.data.getRecommendedUser.similarMatch)
          )
          // setRecommendedUserAbsolute(addRating(response.data.getRecommendedUser.absoluteMatch))
        );
        dispatch(
          // setRecommendedUsers(addRating(response.data.getRecommendedUser)),
          // setRecommendedUsers(addRating(response.data.getRecommendedUser.similarMatch)),
          setRecommendedUserAbsolute(
            addRating(response.data.getRecommendedUser.absoluteMatch)
          )
        );
        dispatch(setOpenJobMatches());
        // navigate("/locum/open-jobs");
      }
    });
  }

  useEffect(() => {
    if (professionalDetails) {
      fetchMinjobRate();
      fetchMinjobHour();
    }
  }, [professionalDetails]);

  useEffect(() => {
    if (professionalDetails) {
      setmyJobDescription();
    } else {
      setJobDescription("");
    }
  }, [professionalDetails]);

  useEffect(() => {
    fetchJobDescription();
  }, []);

  useEffect(() => {
    setClickCount(0);
  }, [professionalDetails.profession, professionalDetails.department]);

  useEffect(() => {
    fetchBranchDetails();
  }, [professionalDetails.hospital]);

  // useEffect(() => {
  //   if (shifts?.length) {
  //     PostLocumJob();
  //   }
  // }, [shifts]);

  // console.log("jobDescription2", jobDescription);
  // console.log("shiftConfig", shiftConfig);
  const isPostDisabled =
    !professionalDetails ||
    !jobDescription ||
    !pocFacilities.pocDetails ||
    !shifts ||
    !shifts.length;
  // (shiftConfig.shiftType === "single"
  //   ? !shiftConfig.professionalCount ||
  //     !shiftConfig.rateOffered ||
  //     !shiftConfig.duration ||
  //     shiftConfig.campDuty === undefined ||
  //     !shiftConfig.startDate ||
  //     !shiftConfig.startTime
  //   : shiftConfig.shiftType === "multiple"
  //   ? !shiftConfig.professionalCount ||
  //     !shiftConfig.rateOffered ||
  //     !shiftConfig.duration ||
  //     shiftConfig.campDuty === undefined ||
  //     !shiftConfig.startDate ||
  //     !shiftConfig.endDate ||
  //     !shiftConfig.startTime
  //   : true);

  const handleCancel = () => {
    if (hasUnsavedChanges) {
      setOpenConfirmModal(true);
      setNavigationCallback(() => () => {
        // Reset form state
        setProfessionalDetails({
          hospital: "",
          department: "",
          profession: "",
          qualification: "",
          specialization: "",
          experience: "",
          skillSet: [],
          hospitalName: "",
          departmentName: "",
          professionName: "",
          specializationName: "",
          qualificationName: "",
          experienceName: "",
        });
        setShiftConfig({
          shiftType: "single",
          professionalCount: "",
          rateOffered: "",
          campDuty: false,
          pocDetails: "",
          startDate: "",
          endDate: "",
          startTime: "",
          duration: "",
          recurringDays: [],
        });
        setPocFacilities({
          pocDetails: "",
          isFood: false,
          isTransport: false,
          isAccommodation: false,
          others: "",
        });
        setJobDescription("");
        setHasUnsavedChanges(false);
        queryClient.removeQueries(["/api/shifts"]);
      });
    } else {
      // Reset form state directly if no changes
      setProfessionalDetails({
        hospital: "",
        department: "",
        profession: "",
        qualification: "",
        specialization: "",
        experience: "",
        skillSet: [],
        hospitalName: "",
        departmentName: "",
        professionName: "",
        specializationName: "",
        qualificationName: "",
        experienceName: "",
      });
      setShiftConfig({
        shiftType: "single",
        professionalCount: "",
        rateOffered: "",
        campDuty: false,
        pocDetails: "",
        startDate: "",
        endDate: "",
        startTime: "",
        duration: "",
        recurringDays: [],
      });
      setPocFacilities({
        pocDetails: "",
        isFood: false,
        isTransport: false,
        isAccommodation: false,
        others: "",
      });
      setJobDescription("");
      queryClient.removeQueries(["/api/shifts"]);
    }
  };

  const handleConfirmDiscard = () => {
    setOpenConfirmModal(false);
    if (navigationCallback) {
      navigationCallback();
      setNavigationCallback(null);
    }
  };

  const handleCancelDiscard = () => {
    setOpenConfirmModal(false);
    setNavigationCallback(null);
  };

  return (
    <div className="main-layout">
      {/* Header */}
      {/* <header className="header">
        <div className="header-content">
          <div className="header-left">
            <div className="header-icon">
              <UserRound size={24} />
            </div>
            <div className="header-text">
              <h1>New Locum Job Posting</h1>
              
            </div>
          </div>
        </div>
      </header> */}
      <h1
        style={{
          fontSize: "24px",
          fontWeight: 600,
          color: "#1a1a1a",
          marginBottom: "16px",
          textAlign: "left",
          fontFamily: '"Segoe UI", Roboto, sans-serif',
          letterSpacing: "0.5px",
          marginLeft: "26px",
          marginTop: "16px",
        }}
      >
        New Locum Job Posting
      </h1>

      <div className="container">
        {/* Posted Jobs History */}
        <PostedJobsHistory onRepostJob={handleRepostJob} />
        {/* AI Requirement Input */}
        {/* <AIRequirementInput onSuggestions={handleAISuggestions} /> */}
        <AntModal
          // title="Credit Limit Exceeded"
          visible={visible}
          onOk={handleOk}
          closable={false}
          // footer={null}
          footer={[
            <Button key="ok" type="primary" onClick={handleOk}>
              OK
            </Button>,
          ]}
          // onCancel={handleCancel}
        >
          <p>Credit Limit Exceeded, Please pay pending bills to use further!</p>
        </AntModal>
        <AntModal
          visible={visibleJobLimit}
          onOk={handleJobLimit}
          closable={false}
          centered
          footer={[
            <Button
              key="ok"
              type="primary"
              onClick={handleJobLimit}
              style={{
                backgroundColor: "#06468c", // Navy blue background
                borderColor: "#001F3F",
                color: "#ffffff", // 👈 White text color (or change as needed)
                fontWeight: 600,
              }}
            >
              OK
            </Button>,
          ]}
          bodyStyle={{
            padding: "24px 32px",
            fontFamily: "Inter, sans-serif",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ fontWeight: 600, fontSize: "1.25rem" }}
          >
            Credit Limit Exceeded
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: "1rem",
              lineHeight: 1.6,
              marginTop: "12px",
            }}
          >
            You have only{" "}
            <strong style={{ color: "#d32f2f" }}>
              ₹{creditRemaining.toLocaleString("en-IN")}
            </strong>{" "}
            credit remaining, which isn’t enough to post this job.
            <br />
            Please reduce the number of shifts or clear the outstanding bill to
            continue posting. <br /> For assistance, contact the finance team at{" "}
            {/* <span style={{ color: "#007bff", fontWeight: 500 }}>
              finance@jobizo.com
            </span> */}
            <a
              href="mailto:finance@jobizo.com"
              style={{ color: "#007bff", textDecoration: "none" }}
            >
              finance@jobizo.com
            </a>{" "}
            .
          </Typography>

          <Typography
            variant="body2"
            sx={{
              marginTop: "20px",
              color: "#666",
              fontSize: "0.9rem",
            }}
          ></Typography>
        </AntModal>

        {/* Final Credit Limit Modal */}
        {/* <AntModal
          visible={visibleFinalTotalCreditLimit}
          onOk={handleFinalCreditLimit}
          onCancel={handleFinalCreditLimit}
          closable={true}
          centered
          // footer={[
          //   <Button
          //     key="ok"
          //     type="primary"
          //     onClick={handleFinalCreditLimit}
          //     style={{
          //       backgroundColor: "#06468c", // Navy blue background
          //       borderColor: "#001F3F",
          //       color: "#ffffff", // 👈 White text color (or change as needed)
          //       fontWeight: 600,
          //     }}
          //   >
          //     OK
          //   </Button>,
          // ]}
          footer={null}
          bodyStyle={{
            textAlign: "center",
            padding: "32px",
            fontFamily: "Inter, sans-serif",
          }}
        >
          <WarningAmberIcon sx={{ fontSize: 48, color: "#ff9800", mb: 1 }} />

          <Typography variant="h6" fontWeight="bold" gutterBottom>
            Job Posting Disabled
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontSize: "1rem",
              lineHeight: 1.6,
              color: "#555",
              marginBottom: "12px",
            }}
          >
            Your branch has reached its credit limit.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: "1rem",
              lineHeight: 1.6,
              marginTop: "16px",
              color: "#555",
            }}
          >
            Please contact our finance team at{" "}
            <a
              href="mailto:finance@jobizo.com"
              style={{ color: "#007bff", textDecoration: "none" }}
            >
              finance@jobizo.com
            </a>{" "}
            to clear outstanding dues and continue posting shifts.
          </Typography>
        </AntModal> */}

        {/* All condtions Apply modal */}
        <AllConditionsModal
          visible={visibleShiftCreditLimitBranchAndDueDate}
          onClose={handleShiftApprovedCreditAndBranch}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />
        {/* Shift credit limit and branch modal */}
        <ShiftCreditLimitAndBranch
          visible={visibleShiftCreditLimitAndBranch}
          onClose={handleShiftCreditLimitAndBranch}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
        />
        {/* Shift credit limit and due date modal */}
        <ShiftCreditLimitAndDueDate
          visible={visibleShiftCreditLimitAndDueDate}
          onClose={handleShiftCreditLimitAndDueDate}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />

        {/* Shift Branch and due date modal*/}
        <ShiftBranchAndDueDate
          visible={visibleShiftAndBranchAndDueDate}
          onClose={handleShiftAndBranchAndDueDate}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />

        {/* credit limit branch and due date modal */}
        <CreditLimitBranchAndDueDate
          visible={visibleCreditLimitBranchAndDueDate}
          onClose={handleCreditLimitBranchAndDueDate}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />

        {/* shift buffer days and credit limit modal */}
        <ShiftApprovalCreditLimitModal
          visible={visibleShiftAndCreditLimit}
          onClose={handleShiftAndCreditLimit}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
        />

        {/* shift buffer days and  Branch activation modal */}
        <ShiftAndBranchActive
          visible={visibleBranchAndShiftApproved}
          onClose={handleBranchAndShiftApproved}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
        />

        {/* shift and due date modal */}
        <ShiftAndDueDate
          visible={visibleShiftAndDueDate}
          onClose={handleShiftAndDueDate}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />

        {/* Branch activation and credit limit modal */}
        <BranchInactiveAndCreditLimit
          visible={visibleBranchActivateAndCreditLimit}
          onClose={handleBranchAndCreditLimit}
        />

        {/* credit limit and due date modal */}
        <CreditLimitAndDueDate
          visible={visibleCreditLimitAndDueDate}
          onClose={handleCreditLimitAndDueDate}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />

        {/* branch and due date modal */}
        <BranchAndDueDate
          visible={visibleBranchAndDueDate}
          onClose={handleBranchAndDueDate}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />

        {/* shift approval modal */}
        <ShiftBufferDaysModal
          visible={visibleShiftApproval}
          onClose={handleShiftApproval}
          onReview={handleOnReview}
          shifts={shiftBufferDays || ""}
        />

        {/* credit limit exchaust modal */}
        <CreditLimitExchaustModal
          visible={visiblePaymentDues}
          onClose={handleFinalCreditLimit}
        />

        {/* branch activation modal */}
        <BranchInactiveModal
          visible={visibleBranchActivate}
          onClose={handleBranchActivate}
        />

        {/* payment due date modal */}
        <PaymentDueDate
          visible={visiblePaymentDueDatePending}
          onClose={handleVisibleDueDate}
          onBilling={handleOnBilling}
          amount={pendingAmount}
        />

        {/* Professional Details Form */}
        <ProfessionalDetailsForm
          details={professionalDetails}
          onChange={setProfessionalDetails}
        />
        {/* Shift Configuration */}
        <ShiftConfiguration
          config={shiftConfig}
          onChange={setShiftConfig}
          onGenerateShifts={handleGenerateShifts}
          isGenerating={generateShifts.isPending}
          minimumHour={minimumHour}
          maximumHour={maximumHour}
          professionalDetails={professionalDetails}
        />
        {/* Shift Management Table */}
        <ShiftManagementTable
          professionalDetails={professionalDetails}
          jobDescription={jobDescription}
          minimumHour={minimumHour}
          maximumHour={maximumHour}
          minJobRate={minJobRate}
        />
        <PocFacilitiesForm
          pocFacilities={pocFacilities}
          onDataChange={setPocFacilities}
        />
        {/* Job Description & Cost Analysis */}
        <JobDescriptionCosts
          jobDescription={jobDescription}
          onJobDescriptionChange={setJobDescription}
          shiftConfig={shiftConfig}
          professionalDetails={professionalDetails}
          generateJobDescription={generateJobDescription}
          isGenerating={isGenerating}
          setTotalCost={setTotalCost}
          clickCount={clickCount}
        />
        {/* need here job post and cancel button */}
        <div className="button-group">
          <button
            className={`btn-primary ${isPostDisabled ? "disabled-btn" : ""}`}
            onClick={PostLocumJob}
            disabled={isPostDisabled || isJobPostLoading}
          >
            {isJobPostLoading ? <CircularProgress /> : "Post a Job!"}
          </button>

          <button className="btn-outline" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
      <SidebarNew hasUnsavedChanges={hasUnsavedChanges} />

      {/* Confirmation Modal */}
      <Modal
        open={openConfirmModal}
        onClose={handleCancelDiscard}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Confirm Discard
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to discard the job? All unsaved changes will
            be lost.
          </Typography>
          <Box
            sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 2 }}
          >
            <Button variant="outlined" onClick={handleCancelDiscard}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleConfirmDiscard}
            >
              Discard
            </Button>
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ShiftManagement;
